module.exports = __webpack_public_path__ + "static/media/AC.17ca9f77.png";